"use client"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"
import { StatusTag } from "@shared/ui/landing/status-tag"

import {
  RISK_CARD_KEYS,
  getRiskCardScore,
  type RiskCardKey,
} from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

import { RiskCardChart } from "./risk-card-chart"

const CHART_COLORS: Record<RiskCardKey, string> = {
  sanctions: "#38bdf8",
  fraud: "#fb7185",
  mixer: "#818cf8",
  exchange: "#34d399",
  whale: "#fbbf24",
  reputation: "#22d3ee",
}

function scoreVariant(score: number) {
  if (score >= 70) return "danger" as const
  if (score >= 45) return "warning" as const
  return "success" as const
}

export function RiskAnalysisSection() {
  const t = useTranslations("risks")

  return (
    <SectionContainer id="risks">
      <div className="mb-10 space-y-3 text-center">
        <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t("title")}</h2>
        <p className="mx-auto max-w-2xl text-muted-foreground">{t("subtitle")}</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {RISK_CARD_KEYS.map((key) => {
          const score = getRiskCardScore(key)
          return (
            <GlassCard key={key} className="space-y-4">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="font-medium">{t(`cards.${key}.title`)}</p>
                  <p className="text-xs text-muted-foreground">
                    {t(`cards.${key}.description`)}
                  </p>
                </div>
                <StatusTag variant={scoreVariant(score)}>{score}</StatusTag>
              </div>
              <RiskCardChart cardKey={key} score={score} color={CHART_COLORS[key]} />
            </GlassCard>
          )
        })}
      </div>
    </SectionContainer>
  )
}
